export default __webpack_public_path__ + "static/klarna_logo-0aae687c9e07a056762b05a0ab691d79.png";